import { render } from "./GenericSettingsTitle.vue?vue&type=template&id=1e3ee6de"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1e3ee6de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e3ee6de', script)) {
    api.reload('1e3ee6de', script)
  }
  
  module.hot.accept("./GenericSettingsTitle.vue?vue&type=template&id=1e3ee6de", () => {
    api.rerender('1e3ee6de', render)
  })

}

script.__file = "src/views/settings/pageTitles/GenericSettingsTitle.vue"

export default script